export function getFileNameWithoutExtension(fileName:string) {
    const lastDotIndex = fileName.lastIndexOf('.');
  
    if (lastDotIndex === -1) {
      return fileName;
    }

    return fileName.slice(0, lastDotIndex);
  }

export function getFileNameWithExtension(inputValue:string, originalFileName:string) {
    const lastDotIndex = originalFileName.lastIndexOf('.');
  
    if (lastDotIndex === -1) {
      return inputValue; 
    }

    const fileExtension = originalFileName.slice(lastDotIndex + 1); 
    const updatedFileName = `${inputValue}.${fileExtension}`;
  
    return updatedFileName;
  }